/**
 * 画面遷移
 */

/**
 * エラーレスポンスからエラーコードとメッセージを取得し、MP9010画面へ遷移する
 * @param error APIエラーレスポンス
 * @param router Angular Router
 */
export function navigateToErrorPage(error: any, router: any): void {
  // HttpErrorResponse の場合、実際のレスポンスボディは error.error に格納される
  // error.resInfo.errorContents[0] からエHostラーコードとメッセージを取得する
  if (error === null) {
    router.navigate(['/mp-app/error'], {
      queryParams: { errorCode: null, errorMessage: null },
    });
  } else {
    const errorContents = error?.resInfo?.errorContents;
    const firstError = Array.isArray(errorContents) ? errorContents[0] : errorContents;
    const errorCodeHost = firstError?.errorCodeHost ?? null;
    const displayErrorMessage = firstError?.errorMsg ?? null;
    // MP9010エラー画面へ遷移し、エラーコードとメッセージをstateで渡す
    router.navigate(['/mp-app/error'], {
      queryParams: { errorCode: errorCodeHost, errorMessage: displayErrorMessage },
    });
  }
}

/**
 * ページを別タブで開く
 * @param url 開くページのURL
 */
export function openInNewTab(url: string): void {
  window.open(url, '_blank', 'noopener,noreferrer');
}

/**
 * アプリ内ルートを別タブで開く
 * @param path ルートパス（例: /mp0011）
 */
export function openRouteInNewTab(path: string): void {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  openInNewTab(`${window.location.origin}${normalizedPath}`);
}
